import React, { useEffect, useState, useCallback } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);

    return debouncedValue;
}

export default function Search() {
    const navigate = useNavigate();
    const location = useLocation();

    const [searchTerm, setSearchTerm] = useState("");
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const debouncedSearchTerm = useDebounce(searchTerm, 300);


    const fetchResults = useCallback((term) => {
        if (!term || !term.trim()) {
            setResults([]);
            setError(null);
            setLoading(false);
            return;
        }

        setResults([]);
        setLoading(true);
        setError(null);

        const requestBody = new URLSearchParams();
        requestBody.append('search_term', term.trim());

        fetch("https://planjourneysglobal.com/admin/api/search_packages", {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: requestBody.toString(),
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.status && data.data && data.data.length > 0) {
                    setResults(data.data);
                    setError(null);
                } else {
                    setResults([]);
                    setError("Data not found for your search.");
                }
            })
            .catch((err) => {
                console.error("Fetch Error:", err);
                setError("Failed to fetch results. Please try again.");
                setResults([]);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const termFromUrl = params.get("search_term");
        setSearchTerm(termFromUrl || "");
    }, [location.search]);

    useEffect(() => {
        fetchResults(debouncedSearchTerm);
    }, [debouncedSearchTerm, fetchResults]);

    const handleSearch = (e) => {
        e.preventDefault();
        if (!searchTerm.trim()) return;
        navigate(`/?search_term=${encodeURIComponent(searchTerm.trim())}`);
    };

 
    return (
        <form onSubmit={handleSearch} style={{ position: 'relative' }}>
           

            <div className="search-group">
                <div className="form-inner2">
                    <input
                        type="text"
                        placeholder="Enter your Package Name"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <button
                        type="submit"
                        disabled={loading}
                    >
                        {loading ? '...' : ''}<i className="bi bi-search"></i>
                    </button>
                </div>
            </div>

            {searchTerm && (loading || error || results.length > 0) && (
                <div className="search-results-dropdown" style={{
                    position: 'absolute',
                    top: '100%',
                    left: '0',
                    right: '0',
                    backgroundColor: 'white',
                    border: '1px solid #ddd',
                    borderRadius: '5px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                    maxHeight: '400px',
                    overflowY: 'auto',
                    zIndex: 1000,
                }}>
                    {loading && <p style={{ padding: '10px', textAlign: 'center' }}>Loading...</p>}
                    {error && <p style={{ color: 'red', padding: '10px' }}>{error}</p>}
                    
                    {!loading && !error && results.length > 0 && (
                        results.map((item) => (
                            <Link
                                to={`/tour-package/${item.slug}`}
                                key={item.id}
                                style={{
                                    display: 'block',
                                    textDecoration: 'none',
                                    color: 'inherit',
                                    padding: "5px 15px",
                                    transition: 'background-color 0.2s',
                                }}
                                onMouseEnter={(e) => e.target.style.backgroundColor = '#f0f0f0'}
                                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                            >
                                <strong style={{ margin: '0 0 5px 0' }}>{item.title}</strong>
                                {/* <p style={{ margin: 0, fontSize: '0.9em', color: '#555' }}>Price: {item.price_inr}</p> */}
                            </Link>
                        ))
                    )}
                </div>
            )}
        </form>
    );
}